import { HTTPRequest } from '@bimser/common';

export function GetDownloadUrl(url: string, req: any) {
	return HTTPRequest.post<any>(url, req);
}
